const colors = {
  primary: {
    dark: '#1a3a1a',
    main: '#2d5a2d',
    light: '#4a7c4a',
    pale: '#6b9e6b',
  },
  accent: {
    gold: '#c9a227',
    copper: '#b87333',
    cream: '#f5f0e1',
  },
  background: {
    dark: '#1a3a1a',
    main: '#0f250f',
    light: '#f8faf8',
    cream: '#fdfcf7',
    white: '#ffffff',
  },
  text: {
    white: '#ffffff',
    light: 'rgba(255, 255, 255, 0.85)',
    muted: 'rgba(255, 255, 255, 0.6)',
    dark: '#1a2e1a',
    body: '#3d4f3d',
    heading: '#1a3a1a',
  },
  gradient: {
    forest: 'linear-gradient(135deg, #1a3a1a 0%, #2d5a2d 100%)',
    nature: 'linear-gradient(180deg, #1a3a1a 0%, #234523 50%, #2d5a2d 100%)',
    gold: 'linear-gradient(135deg, #c9a227 0%, #dbb84d 100%)',
    hero: 'linear-gradient(180deg, rgba(26, 58, 26, 0.9) 0%, rgba(26, 58, 26, 0.7) 50%, rgba(26, 58, 26, 0.85) 100%)',
  },
  border: 'rgba(45, 90, 45, 0.2)',
  borderLight: 'rgba(26, 58, 26, 0.1)',
  shadow: '0 4px 20px rgba(26, 58, 26, 0.15)',
  shadowLight: '0 2px 12px rgba(26, 58, 26, 0.08)',
  shadowGold: '0 4px 20px rgba(201, 162, 39, 0.3)',
};

export default colors;
